import { useNavigate, useLocation } from "react-router-dom";

const NAVBAR_HEIGHT = 80;

/**
 * Shared navigation helper for links that point at a section on the Home
 * page (e.g. Technology, FAQ, Portfolio, Process, Contact section).
 *
 * - If already on Home ("/"), it jumps straight to the section instantly
 *   (no visible scrolling animation).
 * - If on any other page, it navigates to Home first and passes the target
 *   section id via router state; Home.jsx picks this up and performs the
 *   same instant jump once it has mounted.
 */
export default function useSectionScroll() {
  const navigate = useNavigate();
  const location = useLocation();

  return function goToSection(id) {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
      return;
    }

    const section = document.getElementById(id);
    if (!section) return;

    window.scrollTo({
      top: section.offsetTop - NAVBAR_HEIGHT,
      behavior: "auto",
    });
  };
}
